export const SUPPORT_IFRAME = 'hs-web-sdk-iframe';
export const SUPPORT_IFRAME_LAUNCHER = 'hs-web-sdk-iframe-launcher';
